import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const ConfirmDialog = ({ open, onClose, onConfirm, title, message, simple }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title? title: '確認'}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {simple? "": <Button onClick={onClose} color="primary">キャンセル</Button>}
        <Button onClick={onConfirm} color="primary" autoFocus>OK</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;